module.exports = __webpack_public_path__ + "img/2024-10-16c_3.d30f75d9.jpg";